module.exports = __webpack_public_path__ + "static/img/3.3694d72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_image/3.jpg
// module id = chFq
// module chunks = 39